"use client";

import { Typography } from "@/components/ui/typography";
import { faqItems } from "./constants";
import { memo } from "react";
import { cn } from "@/lib/utils";
import {
  FaqStack as FaqStackContent,
  FaqLinkBlock,
} from "@/components/screen/global-components/faq";

const FAQStack = ({ className }: React.ComponentProps<"section">) => {
  return (
    <section className={cn("section bg-background-secondary lg:bg-white", className)}>
      <div className="container mx-auto py-12 lg:py-20">
        <div>
          <Typography
            variant="heading4"
            className="text-semantic-text-primary md:text-gray-800"
            asChild
          >
            <h2>Most popular questions and answers</h2>
          </Typography>
          <FaqStackContent items={faqItems} className="mt-6 md:grid md:grid-cols-2 md:gap-x-4 md:[&>:last-child]:!border-b md:[&>div]:!border-b-gray-100" />
        </div>
        <FaqLinkBlock
          title="Can’t find what you’re looking for? <br />Contact us and we’ll respond within 24 hours or sooner"
          label="Contact support"
          href="/support"
          className="mt-6 py-4 sm:p-0"
        />
      </div>
    </section>
  );
};

export default memo(FAQStack);
